var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "105px",
    viewBox: "0 0 128 105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-8---Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.8--Branding---collect-from-website---enter-url",
    transform: "translate(-656.000000, -301.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Confirmation-message",
    transform: "translate(345.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(312.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,55.2212389 C115,24.7239292 90.375125,0 60,0 C29.624875,0 5,24.7239292 5,55.2212389 C5,63.3470442 6.76275,71.0545487 9.9005,78 L110.0995,78 C113.23725,71.0545487 115,63.3470442 115,55.2212389",
    id: "Fill-1",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,78 L3,78",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,78 L119,78",
    id: "Stroke-7",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,78 L113,78",
    id: "Stroke-3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66,68 C66,69.6571429 52.7914921,71 36.5,71 C20.2066349,71 7,69.6571429 7,68 C7,66.3428571 20.2066349,65 36.5,65 C52.7914921,65 66,66.3428571 66,68",
    id: "Fill-9",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L72.9925241,4.66481481 C72.9925241,2.08888889 70.8843288,0 68.2827261,0 L4.70792903,0 C2.10819529,0 0,2.08888889 0,4.66481481 L0.00747586984,42 L73,42 Z",
    id: "Fill-11",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45488654,42 L52,0 L4.7255673,0 C2.11609365,0 0,2.08888889 0,4.66481481 L0.00750387821,42 L9.45488654,42 Z",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L73,51.3333333 C73,53.9111111 70.8915888,56 68.2878505,56 L4.70841121,56 C2.10841121,56 0,53.9111111 0,51.3333333 L0,42 L73,42 Z",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L73,51.3333333 C73,53.9111111 70.8915888,56 68.2878505,56 L4.70841121,56 C2.10841121,56 0,53.9111111 0,51.3333333 L0,42 L73,42 Z",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,49.5 C39,50.8809524 37.8829365,52 36.5,52 C35.1190476,52 34,50.8809524 34,49.5 C34,48.1210317 35.1190476,47 36.5,47 C37.8829365,47 39,48.1210317 39,49.5",
    id: "Fill-19",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,49.5 C39,50.8809524 37.8829365,52 36.5,52 C35.1190476,52 34,50.8809524 34,49.5 C34,48.1210317 35.1190476,47 36.5,47 C37.8829365,47 39,48.1210317 39,49.5 Z",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "48 66 24 66 25.2 57 46.8 57"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-25",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "48 66 24 66 25.2 57 46.8 57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,66 L55,66",
    id: "Stroke-27",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,42 L72.9925241,4.66481481 C72.9925241,2.08888889 70.8843288,0 68.2827261,0 L4.70792903,0 C2.10819529,0 0,2.08888889 0,4.66481481 L0.00747586984,42 L73,42 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(44.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4617691,51 L3.53823088,51 C1.5922039,51 0,49.3935927 0,47.4302059 L0,12 L59,12 L59,47.4302059 C59,49.3935927 57.4077961,51 55.4617691,51",
    id: "Fill-27",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4617691,51 L3.53823088,51 C1.5922039,51 0,49.3935927 0,47.4302059 L0,12 L59,12 L59,47.4302059 C59,49.3935927 57.4077961,51 55.4617691,51 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,12 L0,12 L0,3.47826087 C0,1.56521739 1.5922039,0 3.53823088,0 L55.4617691,0 C57.4077961,0 59,1.56521739 59,3.47826087 L59,12 Z",
    id: "Fill-31",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,12 L0,12 L0,3.47826087 C0,1.56521739 1.5922039,0 3.53823088,0 L55.4617691,0 C57.4077961,0 59,1.56521739 59,3.47826087 L59,12 Z",
    id: "Stroke-33",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,6 C8,7.10434783 7.10434783,8 6,8 C4.89565217,8 4,7.10434783 4,6 C4,4.89565217 4.89565217,4 6,4 C7.10434783,4 8,4.89565217 8,6",
    id: "Fill-35",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,6 C8,7.10434783 7.10434783,8 6,8 C4.89565217,8 4,7.10434783 4,6 C4,4.89565217 4.89565217,4 6,4 C7.10434783,4 8,4.89565217 8,6 Z",
    id: "Stroke-37",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6 C16,7.10434783 15.1043478,8 14,8 C12.8956522,8 12,7.10434783 12,6 C12,4.89565217 12.8956522,4 14,4 C15.1043478,4 16,4.89565217 16,6",
    id: "Fill-39",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6 C16,7.10434783 15.1043478,8 14,8 C12.8956522,8 12,7.10434783 12,6 C12,4.89565217 12.8956522,4 14,4 C15.1043478,4 16,4.89565217 16,6 Z",
    id: "Stroke-41",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,6 C24,7.10434783 23.1043478,8 22,8 C20.8956522,8 20,7.10434783 20,6 C20,4.89565217 20.8956522,4 22,4 C23.1043478,4 24,4.89565217 24,6",
    id: "Fill-43",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,6 C24,7.10434783 23.1043478,8 22,8 C20.8956522,8 20,7.10434783 20,6 C20,4.89565217 20.8956522,4 22,4 C23.1043478,4 24,4.89565217 24,6 Z",
    id: "Stroke-45",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5507246,33 L19.4492754,33 C18.6492754,33 18,32.3507246 18,31.5507246 L18,26.4492754 C18,25.6492754 18.6492754,25 19.4492754,25 L24.5507246,25 C25.3507246,25 26,25.6492754 26,26.4492754 L26,31.5507246 C26,32.3507246 25.3507246,33 24.5507246,33",
    id: "Fill-47",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5507246,33 L19.4492754,33 C18.6492754,33 18,32.3507246 18,31.5507246 L18,26.4492754 C18,25.6492754 18.6492754,25 19.4492754,25 L24.5507246,25 C25.3507246,25 26,25.6492754 26,26.4492754 L26,31.5507246 C26,32.3507246 25.3507246,33 24.5507246,33 Z",
    id: "Stroke-49",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5507246,33 L33.4492754,33 C32.6492754,33 32,32.3507246 32,31.5507246 L32,26.4492754 C32,25.6492754 32.6492754,25 33.4492754,25 L38.5507246,25 C39.3507246,25 40,25.6492754 40,26.4492754 L40,31.5507246 C40,32.3507246 39.3507246,33 38.5507246,33",
    id: "Fill-51",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5507246,33 L33.4492754,33 C32.6492754,33 32,32.3507246 32,31.5507246 L32,26.4492754 C32,25.6492754 32.6492754,25 33.4492754,25 L38.5507246,25 C39.3507246,25 40,25.6492754 40,26.4492754 L40,31.5507246 C40,32.3507246 39.3507246,33 38.5507246,33 Z",
    id: "Stroke-53",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5507246,33 L46.4492754,33 C45.6492754,33 45,32.3507246 45,31.5507246 L45,26.4492754 C45,25.6492754 45.6492754,25 46.4492754,25 L51.5507246,25 C52.3521739,25 53,25.6492754 53,26.4492754 L53,31.5507246 C53,32.3507246 52.3521739,33 51.5507246,33",
    id: "Fill-55",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5507246,33 L46.4492754,33 C45.6492754,33 45,32.3507246 45,31.5507246 L45,26.4492754 C45,25.6492754 45.6492754,25 46.4492754,25 L51.5507246,25 C52.3521739,25 53,25.6492754 53,26.4492754 L53,31.5507246 C53,32.3507246 52.3521739,33 51.5507246,33 Z",
    id: "Stroke-57",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5507246,45 L19.4492754,45 C18.6492754,45 18,44.3507246 18,43.5507246 L18,38.4492754 C18,37.6492754 18.6492754,37 19.4492754,37 L24.5507246,37 C25.3507246,37 26,37.6492754 26,38.4492754 L26,43.5507246 C26,44.3507246 25.3507246,45 24.5507246,45",
    id: "Fill-59",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5507246,45 L19.4492754,45 C18.6492754,45 18,44.3507246 18,43.5507246 L18,38.4492754 C18,37.6492754 18.6492754,37 19.4492754,37 L24.5507246,37 C25.3507246,37 26,37.6492754 26,38.4492754 L26,43.5507246 C26,44.3507246 25.3507246,45 24.5507246,45 Z",
    id: "Stroke-61",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5507246,45 L33.4492754,45 C32.6492754,45 32,44.3507246 32,43.5507246 L32,38.4492754 C32,37.6492754 32.6492754,37 33.4492754,37 L38.5507246,37 C39.3507246,37 40,37.6492754 40,38.4492754 L40,43.5507246 C40,44.3507246 39.3507246,45 38.5507246,45",
    id: "Fill-63",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5507246,45 L33.4492754,45 C32.6492754,45 32,44.3507246 32,43.5507246 L32,38.4492754 C32,37.6492754 32.6492754,37 33.4492754,37 L38.5507246,37 C39.3507246,37 40,37.6492754 40,38.4492754 L40,43.5507246 C40,44.3507246 39.3507246,45 38.5507246,45 Z",
    id: "Stroke-65",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5507246,45 L46.4492754,45 C45.6492754,45 45,44.3507246 45,43.5507246 L45,38.4492754 C45,37.6492754 45.6492754,37 46.4492754,37 L51.5507246,37 C52.3521739,37 53,37.6492754 53,38.4492754 L53,43.5507246 C53,44.3507246 52.3521739,45 51.5507246,45",
    id: "Fill-67",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5507246,45 L46.4492754,45 C45.6492754,45 45,44.3507246 45,43.5507246 L45,38.4492754 C45,37.6492754 45.6492754,37 46.4492754,37 L51.5507246,37 C52.3521739,37 53,37.6492754 53,38.4492754 L53,43.5507246 C53,44.3507246 52.3521739,45 51.5507246,45 Z",
    id: "Stroke-69",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5507246,20 L7.44927536,20 C6.64927536,20 6,19.3507246 6,18.5507246 L6,17.4492754 C6,16.6492754 6.64927536,16 7.44927536,16 L12.5507246,16 C13.3507246,16 14,16.6492754 14,17.4492754 L14,18.5507246 C14,19.3507246 13.3507246,20 12.5507246,20",
    id: "Fill-71",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5507246,20 L7.44927536,20 C6.64927536,20 6,19.3507246 6,18.5507246 L6,17.4492754 C6,16.6492754 6.64927536,16 7.44927536,16 L12.5507246,16 C13.3507246,16 14,16.6492754 14,17.4492754 L14,18.5507246 C14,19.3507246 13.3507246,20 12.5507246,20 Z",
    id: "Stroke-73",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5080989,20 L19.4919011,20 C18.6683717,20 18,19.3507246 18,18.5507246 L18,17.4492754 C18,16.6492754 18.6683717,16 19.4919011,16 L51.5080989,16 C52.3331202,16 53,16.6492754 53,17.4492754 L53,18.5507246 C53,19.3507246 52.3331202,20 51.5080989,20",
    id: "Fill-75",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5080989,20 L19.4919011,20 C18.6683717,20 18,19.3507246 18,18.5507246 L18,17.4492754 C18,16.6492754 18.6683717,16 19.4919011,16 L51.5080989,16 C52.3331202,16 53,16.6492754 53,17.4492754 L53,18.5507246 C53,19.3507246 52.3331202,20 51.5080989,20 Z",
    id: "Stroke-77",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,25 L14,25",
    id: "Stroke-79",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,29 L14,29",
    id: "Stroke-81",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,33 L14,33",
    id: "Stroke-83",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,37 L14,37",
    id: "Stroke-85",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,41 L14,41",
    id: "Stroke-87",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,45 L11,45",
    id: "Stroke-89",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1392802,67.1655474 C71.8446758,68.2438535 71.252521,68.282154 70.8223986,67.2509869 L64.1555015,51.2502205 C63.7253791,50.2175804 64.2188414,49.7255664 65.2499568,50.1557104 L81.2499207,56.8229419 C82.2825091,57.2530859 82.2442105,57.8437973 81.1644854,58.1398895 L76.0339501,59.5378574 C74.9556981,59.8324766 73.8317824,60.9564487 73.538651,62.0347548 L72.1392802,67.1655474 Z",
    id: "Fill-91",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1392802,67.1655474 C71.8446758,68.2438535 71.252521,68.282154 70.8223986,67.2509869 L64.1555015,51.2502205 C63.7253791,50.2175804 64.2188414,49.7255664 65.2499568,50.1557104 L81.2499207,56.8229419 C82.2825091,57.2530859 82.2442105,57.8437973 81.1644854,58.1398895 L76.0339501,59.5378574 C74.9556981,59.8324766 73.8317824,60.9564487 73.538651,62.0347548 L72.1392802,67.1655474 Z",
    id: "Stroke-93",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon-bubble",
    transform: "translate(91.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#EBA601",
    cx: 11,
    cy: 11,
    r: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "data-sharing",
    transform: "translate(5.000000, 5.000000)",
    fill: "#EBA601",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0388571,1.476 C9.60571337,0.57103181 8.68578607,0.000623529021 7.6826038,0.0149862707 C6.67942153,0.0293490125 5.77620122,0.625859627 5.36914286,1.54285714 L3.08571429,1.54285714 C2.23361781,1.54285714 1.54285714,2.23361781 1.54285714,3.08571429 L1.54285714,5.14285714 C1.54285714,5.4268893 1.7731107,5.65714286 2.05714286,5.65714286 C2.34117501,5.65714286 2.57142857,5.4268893 2.57142857,5.14285714 L2.57142857,3.08571429 C2.57142857,2.80168213 2.80168213,2.57142857 3.08571429,2.57142857 L4.51542857,2.57142857 C4.25942273,2.85307046 4.11655403,3.21940048 4.11428571,3.6 C4.11428571,4.45209647 4.80504639,5.14285714 5.65714286,5.14285714 L9.42685714,5.14285714 C10.3519371,5.14952178 11.1447286,4.48297076 11.2970223,3.57048839 C11.449316,2.65800603 10.9159606,1.77012054 10.0388571,1.476 Z M9.42685714,4.11428571 L5.65714286,4.11428571 C5.3731107,4.11428571 5.14285714,3.88403216 5.14285714,3.6 C5.14285714,3.31596784 5.3731107,3.08571429 5.65714286,3.08571429 C5.94117501,3.08571429 6.17142857,2.85546073 6.17142857,2.57142857 C6.16285567,1.81325899 6.70644825,1.16122951 7.45378917,1.03326018 C8.20113009,0.905290839 8.93069069,1.33931464 9.17485714,2.05714286 C9.23475628,2.2372142 9.3889533,2.36966548 9.576,2.40171429 C9.99173067,2.47059005 10.293935,2.83411126 10.2857143,3.25542857 C10.2857143,3.48321165 10.1952278,3.70166532 10.0341609,3.86273228 C9.87309389,4.02379924 9.65464022,4.11428571 9.42685714,4.11428571 Z M9.25714286,6.17142857 C8.9731107,6.17142857 8.74285714,6.40168213 8.74285714,6.68571429 L8.74285714,8.22857143 C8.74285714,8.51260359 8.51260359,8.74285714 8.22857143,8.74285714 L7.06628571,8.74285714 C6.86511302,8.22772434 6.44758423,7.82712239 5.92457143,7.64742857 C5.4463038,6.6324577 4.36516421,6.04476475 3.25330755,6.19536544 C2.14145089,6.34596613 1.25560457,7.2000868 1.06457143,8.30571429 C0.345159057,8.54216728 -0.096300413,9.26578273 0.0225937413,10.0136653 C0.141487896,10.7615479 0.78558487,11.3125877 1.54285714,11.3142857 L5.31257143,11.3142857 C6.22121332,11.3142857 7.00014654,10.6651747 7.164,9.77142857 L8.22857143,9.77142857 C9.0806679,9.77142857 9.77142857,9.0806679 9.77142857,8.22857143 L9.77142857,6.68571429 C9.77142857,6.40168213 9.54117501,6.17142857 9.25714286,6.17142857 Z M5.31257143,10.2857143 L1.54285714,10.2857143 C1.25882499,10.2857143 1.02857143,10.0554607 1.02857143,9.77142857 C1.02857143,9.48739641 1.25882499,9.25714286 1.54285714,9.25714286 C1.8268893,9.25714286 2.05714286,9.0268893 2.05714286,8.74285714 C2.04856996,7.98468756 2.59216253,7.33265808 3.33950345,7.20468875 C4.08684438,7.07671941 4.81640498,7.51074321 5.06057143,8.22857143 C5.12047057,8.40864277 5.27466759,8.54109405 5.46171429,8.57314286 C5.87744496,8.64201862 6.17964933,9.00553983 6.17142857,9.42685714 C6.17142857,9.65464022 6.0809421,9.87309389 5.91987514,10.0341609 C5.75880818,10.1952278 5.54035451,10.2857143 5.31257143,10.2857143 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon-bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 13.5,
    cy: 13.5,
    r: 13.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#1DDCC0",
    cx: 13.5,
    cy: 13.5,
    r: 13.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(6.000000, 6.000000)",
    fill: "#1DDCC0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1099221,5.39672727 L6.70020779,8.81438961 L5.38877922,7.50296104 C5.19453687,7.27614258 4.88954746,7.1773437 4.59920466,7.24718467 C4.30886186,7.31702564 4.0821685,7.54371901 4.01232753,7.8340618 C3.94248656,8.1244046 4.04128544,8.42939402 4.2681039,8.62363636 L6.1358961,10.4993766 C6.28589081,10.6481534 6.4889462,10.7310916 6.70020779,10.7298701 C6.90871689,10.7289922 7.10853051,10.6462122 7.25657143,10.4993766 L11.2305974,6.52535065 C11.3810641,6.37611278 11.4656994,6.17296386 11.4656994,5.96103896 C11.4656994,5.74911406 11.3810641,5.54596514 11.2305974,5.39672727 C10.9205936,5.08856255 10.4199259,5.08856255 10.1099221,5.39672727 Z M7.94805195,3.52964411e-16 C3.55846407,-1.76482205e-16 3.52964411e-16,3.55846407 0,7.94805195 C-3.52964411e-16,12.3376398 3.55846407,15.8961039 7.94805195,15.8961039 C12.3376398,15.8961039 15.8961039,12.3376398 15.8961039,7.94805195 C15.8961039,5.84009751 15.0587223,3.8184794 13.5681734,2.32793052 C12.0776245,0.83738164 10.0560064,1.76482205e-16 7.94805195,3.52964411e-16 Z M7.94805195,14.3064935 C4.43638164,14.3064935 1.58961039,11.4597223 1.58961039,7.94805195 C1.58961039,4.43638164 4.43638164,1.58961039 7.94805195,1.58961039 C11.4597223,1.58961039 14.3064935,4.43638164 14.3064935,7.94805195 C14.3064935,9.6344155 13.6365882,11.25171 12.4441491,12.4441491 C11.25171,13.6365882 9.6344155,14.3064935 7.94805195,14.3064935 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect);
export default __webpack_public_path__ + "static/media/collect.c75cfbf99e4d944b42f4fe600a2c1604.svg";
export { ForwardRef as ReactComponent };